module.exports = __webpack_public_path__ + "img/whole_foods.5d02fb36.png";